import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequestForApiV4 } from 'utils/http'
import { IPerformerData } from 'meta/pages/v4/performer'

type Props = {
  codes: string[]
}

type Response = { items: IPerformerData[] }

export const getBulkData = async (props: Props): Promise<Response> => {
  const { codes } = props

  const endpoint = ApiEndpoint.v4.performer.bulk(codes)

  const { data } = await HttpRequestForApiV4.get<Response>(endpoint)
  return data
}
